import React, { useState } from 'react';
import classes from './FeatureCards.module.css';
import { Card, Col, Row } from 'react-bootstrap';

export const FeatureCards = (props) => {
    const [cardDetails, setCardDetails] = useState(props.cardDetails || []);
    const mediaContent = process.env.REACT_APP_MEDIA_CONTENT;

    return (
        <>
            <div className={classes.scrollWrapper}>
                <Row className={classes.cardSection}>
                    {cardDetails.map((card, index) => (
                        <Col key={index} xs={12} sm={6} md={4} lg={4}>
                            <Card className={classes.card}>
                                {card.image && (
                                    <Card.Img
                                        variant="top"
                                        src={`${mediaContent}${card.image}`}
                                        alt={card.title || 'Feature Image'}
                                        className={classes.cardImageSection}
                                    />
                                )}
                                <Card.Body className={classes.cardBody}>
                                    <Card.Title className={classes.cardTitle}>{card.title}</Card.Title>
                                    <Card.Text className={classes.cardDescription}>{card.description}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>

        </>
    );
};
